const isNumberStringValid = (str: string) => !isNaN(Number(str)) && !isNaN(parseFloat(str))

export default isNumberStringValid
